import i18n from "i18next";
import { initReactI18next } from "react-i18next";

import en from "./locales/en.json";
import es from "./locales/es.json";
import fr from "./locales/fr.json";
import pt from "./locales/pt.json";
import de from "./locales/de.json";
import it from "./locales/it.json";
import hi from "./locales/hi.json";
import zh from "./locales/zh.json";
import ja from "./locales/ja.json";
import ko from "./locales/ko.json";
import ar from "./locales/ar.json";
import ru from "./locales/ru.json";
import vi from "./locales/vi.json";

export const LANGUAGES = [
  { code: "en", label: "English", flag: "🇺🇸" },
  { code: "es", label: "Español", flag: "🇪🇸" },
  { code: "fr", label: "Français", flag: "🇫🇷" },
  { code: "pt", label: "Português", flag: "🇧🇷" },
  { code: "de", label: "Deutsch", flag: "🇩🇪" },
  { code: "it", label: "Italiano", flag: "🇮🇹" },
  { code: "hi", label: "हिन्दी", flag: "🇮🇳" },
  { code: "zh", label: "中文", flag: "🇨🇳" },
  { code: "ja", label: "日本語", flag: "🇯🇵" },
  { code: "ko", label: "한국어", flag: "🇰🇷" },
  { code: "ar", label: "العربية", flag: "🇸🇦" },
  { code: "ru", label: "Русский", flag: "🇷🇺" },
  { code: "vi", label: "Tiếng Việt", flag: "🇻🇳" },
];

const saved = localStorage.getItem("airpog_lang");
const browser = (navigator.language || "en").split("-")[0];
const initial = saved || (LANGUAGES.some((l) => l.code === browser) ? browser : "en");

i18n.use(initReactI18next).init({
  resources: { en: { translation: en }, es: { translation: es }, fr: { translation: fr },
               pt: { translation: pt }, de: { translation: de }, it: { translation: it },
               hi: { translation: hi }, zh: { translation: zh }, ja: { translation: ja },
               ko: { translation: ko }, ar: { translation: ar }, ru: { translation: ru },
               vi: { translation: vi } },
  lng: initial,
  fallbackLng: "en",
  interpolation: { escapeValue: false },
});

export const setLanguage = (code) => {
  localStorage.setItem("airpog_lang", code);
  i18n.changeLanguage(code);
  document.documentElement.lang = code;
};

document.documentElement.lang = initial;

export default i18n;
